import { Button } from "@softmax/design-system";
import * as stylex from "@stylexjs/stylex";
import { EditableFieldView } from "./editable-field-view";
import type { EditableBeat, EditorBeat } from "./beat-records";
import { beatStyles as styles } from "./beats.stylex";

export type EditableBeatRowProps = Readonly<{
  beat: EditableBeat;
  index: number;
  loading: boolean;
  maxTitleLength: number;
  maxBodyLength: number;
  fitPreview(text: string): string | null;
  onUpdate(
    change: Readonly<{ index: number; patch: Partial<EditorBeat> }>,
  ): void;
  onRemove(index: number): void;
}>;

export function EditableBeatRow({
  beat,
  index,
  loading,
  maxTitleLength,
  maxBodyLength,
  fitPreview,
  onUpdate,
  onRemove,
}: EditableBeatRowProps) {
  return (
    <li {...stylex.props(styles.beat)}>
      <span {...stylex.props(styles.number)}>
        {String(index + 1).padStart(2, "0")}
      </span>
      <div {...stylex.props(styles.content)}>
        <EditableFieldView
          editing
          loading={loading}
          value={beat.title}
          liveValue={beat.title}
          onChange={(title) => onUpdate({ index, patch: { title } })}
          maxLength={maxTitleLength}
          ariaLabel={`Edit beat ${index + 1} title`}
          variant="beatTitle"
          lintWarnings={beat.titleWarnings}
        />
        <EditableFieldView
          editing
          loading={loading}
          value={beat.body}
          liveValue={beat.body}
          onChange={(body) => onUpdate({ index, patch: { body } })}
          maxLength={maxBodyLength}
          ariaLabel={`Edit beat ${index + 1} body`}
          fitPreview={fitPreview}
          lintWarnings={beat.bodyWarnings}
        />
        <div>
          <Button
            size="sm"
            variant="quiet"
            disabled={loading}
            onClick={() => onRemove(index)}
          >
            Remove beat
          </Button>
        </div>
      </div>
    </li>
  );
}
